import "./OurCraftsmanship.module.css";
import Header from "@/reusable_sections/Header";
import ThePortfolio from "./sections/ThePortfolio";
import TheMagicBehindTheLens from "./sections/TheMagicBehindTheLens";
import Footer from "@/reusable_sections/Footer";
export default function OurCraftsmanshipPage() {
  return <div>
      <Header />
      <ThePortfolio />
      <TheMagicBehindTheLens />
      <Footer />
    </div>;
}